import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../../mock';

const linkClass = 'text-cyan-400 hover:text-yellow-400 transition-colors';

const InfoRow = ({ icon: Icon, title, children }) => (
  <div className="flex items-start space-x-4">
    <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
      <Icon className="w-6 h-6 text-black" />
    </div>
    <div>
      <h3 className="font-semibold text-white mb-1">{title}</h3>
      {children}
    </div>
  </div>
);

export const ContactInfo = () => (
  <div>
    <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Get Your <span className="text-yellow-400">Free Estimate</span></h2>
    <p className="text-lg text-gray-400 mb-8">Fill out the form and we'll get back to you within 24 hours. For emergencies, call us directly.</p>
    <div className="space-y-6">
      <InfoRow icon={Phone} title="Phone">
        <a href={`tel:${companyInfo.phone}`} className={linkClass} data-testid="contact-phone-link">{companyInfo.phone}</a>
      </InfoRow>
      <InfoRow icon={Mail} title="Email">
        <a href={`mailto:${companyInfo.email}`} className={linkClass} data-testid="contact-email-link">{companyInfo.email}</a>
      </InfoRow>
      <InfoRow icon={MapPin} title="Location">
        {companyInfo.locations.map((location) => <p key={location} className="text-gray-400">{location}</p>)}
      </InfoRow>
      <InfoRow icon={Clock} title="Hours">
        <p className="text-gray-400">{companyInfo.hours}</p>
      </InfoRow>
    </div>
  </div>
);
